module.exports = __webpack_public_path__ + "static/img/14001536.cbb919d4.png";